module.exports = __webpack_public_path__ + "static/media/bai_btn3.ffe27c0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/bai_btn3.png
// module id = 1469
// module chunks = 0